import React, { useState } from "react";
import HrLayout from "../../layouts/HrLayout";
import Card from "../../components/UI/Card";
import Button from "../../components/UI/Button";
import { FiCheckCircle, FiXCircle, FiFilter } from "react-icons/fi";

export default function Leaves() {
  const [filterStatus, setFilterStatus] = useState("All");
  const [filterType, setFilterType] = useState("All");

  const initialLeaves = [
    {
      id: 1,
      employee: "John Doe",
      type: "Sick Leave",
      from: "2025-12-01",
      to: "2025-12-03",
      reason: "High Fever & Doctor Advised Rest",
      appliedOn: "2025-11-29",
      approver: "HR Manager",
      balance: 6,
      status: "Approved",
    },
    {
      id: 2,
      employee: "Jane Smith",
      type: "Casual Leave",
      from: "2025-12-05",
      to: "2025-12-06",
      reason: "Family Event",
      appliedOn: "2025-11-30",
      approver: "Team Lead",
      balance: 8,
      status: "Pending",
    },
    {
      id: 3,
      employee: "Mike Johnson",
      type: "Work From Home",
      from: "2025-12-04",
      to: "2025-12-04",
      reason: "Personal Work",
      appliedOn: "2025-12-02",
      approver: "HR Manager",
      balance: 12,
      status: "Rejected",
    },
  ];

  const [leaves, setLeaves] = useState(initialLeaves);

  const handleApprove = (id) => {
    setLeaves(leaves.map(l => (l.id === id ? { ...l, status: "Approved" } : l)));
  };

  const handleReject = (id) => {
    setLeaves(leaves.map(l => (l.id === id ? { ...l, status: "Rejected" } : l)));
  };

  const getStatusBadge = (status) => {
    if (status === "Approved")
      return "bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold";
    if (status === "Pending")
      return "bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-xs font-semibold";
    return "bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-semibold";
  };

  const filteredLeaves = leaves.filter((l) => {
    return (
      (filterStatus === "All" || l.status === filterStatus) &&
      (filterType === "All" || l.type === filterType)
    );
  });

  return (
    <HrLayout>
      <div className="p-6 bg-gray-100 min-h-screen">

        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Leave Management</h1>

          <div className="flex gap-3">
            {/* Filter by Type */}
            <select
              className="px-3 py-2 rounded-lg shadow bg-white border text-sm"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
            >
              <option value="All">All Types</option>
              <option value="Sick Leave">Sick Leave</option>
              <option value="Casual Leave">Casual Leave</option>
              <option value="Work From Home">Work From Home</option>
            </select>

            {/* Filter by Status */}
            <select
              className="px-3 py-2 rounded-lg shadow bg-white border text-sm"
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
            >
              <option value="All">All Status</option>
              <option value="Approved">Approved</option>
              <option value="Pending">Pending</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>
        </div>

        {/* Table */}
        <Card>
          <table className="min-w-full bg-white rounded shadow">
            <thead className="bg-gray-100 text-gray-600 text-sm uppercase">
              <tr>
                <th className="py-3 px-4 text-left">Employee</th>
                <th className="py-3 px-4 text-left">Type</th>
                <th className="py-3 px-4 text-left">From</th>
                <th className="py-3 px-4 text-left">To</th>
                <th className="py-3 px-4 text-left">Balance</th>
                <th className="py-3 px-4 text-left">Reason</th>
                <th className="py-3 px-4 text-left">Applied On</th>
                <th className="py-3 px-4 text-left">Approver</th>
                <th className="py-3 px-4 text-left">Status</th>
                <th className="py-3 px-4 text-center">Actions</th>
              </tr>
            </thead>

            <tbody className="text-gray-800 text-sm">
              {filteredLeaves.map((l) => (
                <tr key={l.id} className="border-b hover:bg-gray-50 transition">
                  <td className="py-3 px-4 font-medium">{l.employee}</td>
                  <td className="py-3 px-4">{l.type}</td>
                  <td className="py-3 px-4">{l.from}</td>
                  <td className="py-3 px-4">{l.to}</td>
                  <td className="py-3 px-4 font-semibold">{l.balance} days</td>
                  <td className="py-3 px-4 w-56">{l.reason}</td>
                  <td className="py-3 px-4">{l.appliedOn}</td>
                  <td className="py-3 px-4">{l.approver}</td>
                  <td className="py-3 px-4">
                    <span className={getStatusBadge(l.status)}>{l.status}</span>
                  </td>

                  <td className="py-3 px-4 text-center">
                    <div className="flex gap-3 justify-center">

                      {/* Approve */}
                      <button
                        className="text-green-600 hover:text-green-800"
                        onClick={() => handleApprove(l.id)}
                      >
                        <FiCheckCircle size={20} />
                      </button>

                      {/* Reject */}
                      <button
                        className="text-red-600 hover:text-red-800"
                        onClick={() => handleReject(l.id)}
                      >
                        <FiXCircle size={20} />
                      </button>

                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>
    </HrLayout>
  );
}
